import t from 'tcomb';

const Language = t.enums.of(['it', 'en', 'fr', 'es', 'de', 'pt']);

module.exports = Language;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Language.js
 **/